import { useState } from "react";
import { IMaskInput } from "react-imask";

export default function AccountInput({
  label,
  value,
  onChange,
  type = "text",
  disabled = false,
  name,
  showPasswordToggle = false,
  mask = null,
  isPhoneInput = false,
  className,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password" && showPasswordToggle;

  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  const commonClassName =
    "border-0 border-b-2 border-[#4962d8] focus:border-[#4962d8] focus:outline-none focus:shadow-none text-sm py-1 px-0 bg-transparent text-black font-medium disabled:bg-transparent disabled:text-black pr-10";

  const finalMask = isPhoneInput ? "+{1} (000) 000-0000" : mask;

  const handleAccept = (val) => {
    const syntheticEvent = {
      target: { name, value: val },
      currentTarget: { name, value: val },
    };
    onChange(syntheticEvent);
  };

  return (
    <div className="relative flex flex-col mb-4 flex-1 min-w-[180px]">
      <label className="text-xs font-semibold text-[#837f90] mb-1">
        {label}
      </label>

      {finalMask ? (
        <IMaskInput
          mask={finalMask}
          value={value}
          unmask={false}
          placeholderChar="-"
          onAccept={handleAccept}
          disabled={disabled}
          name={name}
          type={inputType}
          className={className ? className : commonClassName}
          autoComplete={isPassword ? "new-password" : undefined}
          {...rest}
        />
      ) : (
        <input
          className={className ? className : commonClassName}
          type={inputType}
          value={value}
          onChange={onChange}
          disabled={disabled}
          name={name}
          autoComplete={isPassword ? "new-password" : undefined}
          {...rest}
        />
      )}

      {isPassword && (
        <button
          type="button"
          tabIndex={-1}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#4962d8] focus:outline-none"
          onClick={() => setShowPassword((v) => !v)}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          <i
            className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"} text-lg`}
          ></i>
        </button>
      )}
    </div>
  );
}
